export function toNumber(ammount) {
  return Number(ammount || 0);
}
